import { ListboxSelect } from "@evertrue/et-components";
import { JourneysContext } from "apps/journeys/context/journeys-context";
import { useContext, useState, useEffect } from "react";

// this only really exists for testing purposes and to make life easier for folks doing demos in stage environments
// there will be a whole redesign later on that will make this component obsolete

const JourneyGroupSelector = () => {
  const { journeyGroups, setSelectedJourneyGroup, selectedJourneyGroup } = useContext(JourneysContext);
  const [selected, setSelected] = useState({});
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!journeyGroups || journeyGroups.length <= 1) return;
    if (journeyGroups && journeyGroups.length) {
      setOptions(
        journeyGroups.map((j) => {
          return { label: j.name, value: j.id, key: `${j.name}-${j.id}` };
        })
      );
    }

    if (selectedJourneyGroup && selectedJourneyGroup.id) {
      setSelected({
        label: selectedJourneyGroup.name,
        value: selectedJourneyGroup.id,
        key: `${selectedJourneyGroup.name}-${selectedJourneyGroup.id}`,
      });
    }
  }, [selectedJourneyGroup, journeyGroups]);

  const handleSelect = (val) => {
    setSelected(val);
    const { value: journeyGroupId } = val;
    const foundJourneyGroup = journeyGroups.find((j) => j.id === journeyGroupId);
    setSelectedJourneyGroup(foundJourneyGroup);
  };
  if (!journeyGroups || journeyGroups.length <= 1) return;

  return (
    <div style={{ paddingLeft: "20px" }}>
      <ListboxSelect size="small" label="test" options={options} onChange={handleSelect} value={selected} />
    </div>
  );
};

export default JourneyGroupSelector;
